import React from 'react'
import {NavigationDOts, SocialMedia} from '../components'

const AppWrapp = (Component, idName, classNames) => function HOC() {
  return (
    <div 
    id={idName}
    className={`app__container ${classNames}`}
    >
      <SocialMedia />

      <div className='app__wrapper app__flex'>
        <Component />

        <div className='copyright'>
            <p className='p-text'>@2024 Fernando L</p>
        </div>
      </div>
      <NavigationDOts active={idName}/>
    </div>
  )
}

export default AppWrapp
